export enum ServiceType {
  Location = "LOCATION",
  Spectacle = "SPECTACLE",
  RelaisColis = "RELAIS",
}